'use strict';

const { queryAll, queryFirst } = require('./domUtil');
document.addEventListener('DOMContentLoaded', () => {

    const faqContainer = queryFirst('#general-section');
    if (faqContainer) {
        const faqElements = queryAll('.collapsible', faqContainer);
        const faqList = [];
        faqElements.forEach(faqElement => {
            const question = queryFirst('.question', faqElement).innerText.replace(/\s\s+/g, ' ')
            const questionFormatted = question.substring(0, question.indexOf('?') + 1);
            const answer = queryFirst('.answer', faqElement).innerText.replace(/[\r\n\t]/g, ' ').replace(/\s\s+/g, ' ');
            faqList.push({
                "@type": "Question",
                "name": questionFormatted,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answer
                }
            });
        });
        const faqScriptObject = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqList
        }
        const faqScriptElement = document.createElement("script");
        faqScriptElement.id = "saleFaqScript";
        faqScriptElement.type = "application/ld+json";
        faqScriptElement.innerHTML = JSON.stringify(faqScriptObject);
        document.head.appendChild(faqScriptElement);
    }
});
